import { render, staticRenderFns } from "./IconClearCoupon.vue?vue&type=template&id=64b61de6"
import script from "./IconClearCoupon.vue?vue&type=script&lang=js"
export * from "./IconClearCoupon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports